import React, {FormEvent, useEffect, useRef, useState} from "react";

import {registerPasswordReset} from "../../api/auth-api";
import {AxiosError} from "axios";
import Form from "react-bootstrap/Form";
import {Alert, Button} from "react-bootstrap";
import {Page} from "../../common/Page";

export const ResetPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<AxiosError | null>(null);
  const emailField = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    registerPasswordReset(email)
      .then(() => {
          setSubmitting(false);
          setSubmitted(true);
        },
        (error: AxiosError) => {
          setSubmitting(false);
          setError(error);
        })
  };

  useEffect(() => {
    if (error) {
      emailField.current?.focus();
      emailField.current?.select();
    }
  }, [error]);

  return (
    <Page title={"Reset password"}>
      <p>To reset your password, enter your email address and we will send you a password reset link.</p>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="requestPasswordReset.email">
          <Form.Label>Email address</Form.Label>
          <Form.Control ref={emailField}
                        type="email"
                        placeholder="name@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={submitting || submitted}
                        autoComplete="username"
                        autoFocus={true}
                        required={true}
          />
        </Form.Group>
        <Button type={'submit'}
                variant={'primary'}
                className={'mb-3'}
                disabled={submitting || submitted}>Send link</Button>
        {error && <Alert variant={"danger"} className={'mb-3'}>
          <Alert.Heading>Request failed</Alert.Heading>
          <p>An error occurred. Please try again.</p>
        </Alert>}
        {submitted && <Alert variant={"success"} className={'mb-3'}>
          <Alert.Heading>Password reset email sent</Alert.Heading>
          <p>Follow the link in the email to continue creating your account.</p>
          <p>Please allow a few minutes for the email to arrive.</p>
          <p>If you don't see the email within a few minutes, please check your spam or junk folder.</p>
        </Alert>}
      </Form>
    </Page>
  )
    ;

}